import React from "react";
import InputFactory from "../InputFactory";

export default function CustomFactoryClient({
  schema,
  onChange,
  object,
  fieldsToExlude,
  fieldToDisable,
  navigateBack,
}) {
  // Helper: decide if a field should be shown based on an "if" clause in the schema
  const shouldShowField = (fieldDef, obj) => {
    if (!fieldDef?.if) return true;
    // Support a single key/value condition like: { if: { group: "OUTSIDE" } }
    const [depField, depValue] = Object.entries(fieldDef.if)[0] || [];
    if (!depField) return true;
    return obj?.[depField] === depValue;
  };

  return (
    <>
      <div className="d-flex flex-column row gap-5">
        {schema.map((section) => {
          const fieldKeys = Object.keys(section.fields || {});
          return (
            <div key={section.name || "_root"}>
              <h5 className="fw-bold text-primary">{section.name}</h5>
              {section.name ? (
                <hr
                  className="pb-2"
                  style={{ borderTop: "1px solid rgba(0, 0, 0, .2)" }}
                />
              ) : null}

              <div className="row">
                {fieldKeys.map((key, index) => {
                  const fieldDef = section.fields[key];

                  // Hide excluded fields
                  if (fieldsToExlude && fieldsToExlude.includes(key))
                    return null;

                  // Honor conditional display (e.g., show only if group === "OUTSIDE")
                  if (!shouldShowField(fieldDef, object)) return null;

                  // Build props
                  let disable = false;
                  let { type, value, ...options } = fieldDef || {};
                  const colClass = options.col || "col-4";

                  // Disable logic (and convert Pointer/Relation to String snapshot)
                  if (fieldToDisable && fieldToDisable.includes(key)) {
                    if (type === "Pointer") {
                      value = object?.[key]?.name;
                      type = "String";
                    }
                    if (type === "Relation") {
                      value = object?.[key]?.[0]?.name;
                      type = "String";
                    }
                    disable = true;
                  }

                  const isLast = index !== fieldKeys.length - 1 ? "mb-4" : "";

                  return (
                    <div className={`${colClass} ${isLast}`} key={key}>
                      {options.label ? (
                        <label
                          className="form-label fw-semibold"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {options.label}
                          {(options.required || options._required) && (
                            <span className="text-danger ms-1">*</span>
                          )}
                        </label>
                      ) : null}

                      <InputFactory
                        field={key}
                        key={key}
                        object={object}
                        type={type}
                        {...(disable ? { value } : {})}
                        disabled={disable}
                        onChange={onChange}
                        {...options}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <div className="d-flex gap-3 w-100 justify-content-center mt-5">
        <button
          type="button"
          style={{ width: "8rem" }}
          className="btn btn-light"
          onClick={navigateBack}
        >
          Cancel
        </button>
        <button style={{ width: "8rem" }} className="btn btn-primary">
          Save
        </button>
      </div>
    </>
  );
}
